import styled from 'styled-components';

export const StyledForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StyledInput = styled.input`
  width: 200px;
  padding: 10px;
  border: none;
  border-radius: 4px;
  color: #000;
  outline: none;
`;
